import { render } from "./editar.vue?vue&type=template&id=20e5b74b&scoped=true"
import script from "./editar.vue?vue&type=script&lang=js"
export * from "./editar.vue?vue&type=script&lang=js"

import "./editar.vue?vue&type=style&index=0&id=20e5b74b&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src407097413/src/Abbott-Seguimiento-Email-Backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e5b74b"]])

export default __exports__